"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const result = {
    "possibleTypes": {
        "AbuseReportable": [
            "AcceptedSolutionMessage",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "PrivateConversation",
            "PrivateNote",
            "TkbReplyMessage",
            "TkbTopicMessage",
            "User"
        ],
        "AcceptInviteError": [
            "MembershipActionNotAllowed",
            "MembershipInviteNotFound"
        ],
        "AcceptedSolutionsAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "AddArticleToChapterError": [
            "AddArticleError",
            "GuideNotEnabledError",
            "InvalidArticleError",
            "InvalidChapterError",
            "MaximumEntriesAdded",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "AddArticleToGuideError": [
            "AddArticleError",
            "GuideNotEnabledError",
            "InvalidArticleError",
            "InvalidGuideError",
            "MaximumEntriesAdded",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "AddHelpfulnessToTKBMessageError": [
            "AddHelpfulnessToTKBMessageFailedError"
        ],
        "AddPlusOneToMessageError": [
            "AddPlusOneToMessageFailedError"
        ],
        "AddRatingToMessageError": [
            "AddRatingToMessageFailedError"
        ],
        "AddRuleError": [
            "DefaultError",
            "MaxRulesLimitError",
            "MaxWordsLimitError",
            "RulesOverlapped"
        ],
        "AddTagToMessageError": [
            "AddTagLimitReachedError",
            "AddTagToMessageFailedError"
        ],
        "AddTempUploadError": [
            "FileNotSpecifiedError"
        ],
        "AddUpdatePromotedSearchRuleError": [
            "InvalidRuleId",
            "KeywordEmptyError",
            "UnsupportedContentTypeError",
            "UrlDoesNotExistsError",
            "UrlEmptyError"
        ],
        "AddUsersToRoleError": [
            "GreaterThanMaxValueError"
        ],
        "AllowedCustomFieldsError": [
            "InvalidNodeTypeError"
        ],
        "AnalyticsError": [
            "NoParentFrame"
        ],
        "AnalyticsSettingsAdministrative": [
            "Community"
        ],
        "AnalyticsSettingsError": [
            "InvalidRole"
        ],
        "ApiAppErrors": [
            "AppNotFoundError",
            "AuthServiceRemoteError",
            "ClientCredentialsNotEnabledError",
            "PermissionDeniedError",
            "RequiredFieldEmptyError",
            "ValidationError"
        ],
        "ApproveRequestError": [
            "MembershipActionNotAllowed",
            "MembershipNodeNotFound",
            "MembershipNotApproved",
            "MembershipRequestNotFound"
        ],
        "ArchiveMessageError": [
            "AlreadyArchivedMessageError",
            "ArchivalFeatureNotEnabledError",
            "InvalidUrlError",
            "MessageArchivalFailedError",
            "MessageArchivalQueuedError",
            "MessageNotFoundError",
            "MessageReplyArchivalNotAllowedError",
            "PermissionDeniedError"
        ],
        "Article": [
            "BlogTopicMessage",
            "TkbTopicMessage"
        ],
        "AssetError": [
            "AssetAlreadyExistsError",
            "AssetDoesNotExistError",
            "InvalidAssetDirectoryNameError",
            "InvalidAssetNameError"
        ],
        "AssetInfoError": [
            "AssetAlreadyExistsError",
            "AssetDoesNotExistError"
        ],
        "AssetNameError": [
            "AssetAlreadyExistsError",
            "AssetDoesNotExistError"
        ],
        "AttachmentAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "AttachmentsApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "AttachmentsContainer": [
            "BlogReplyMessage",
            "BlogTopicMessage",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "PrivateNote",
            "Revision",
            "TkbReplyMessage",
            "TkbTopicMessage"
        ],
        "AuthAdministrative": [
            "Community"
        ],
        "AuthApplicable": [
            "Community"
        ],
        "AuthProviderConfigurationError": [
            "IncorrectProviderConfigurationSizeError",
            "InvalidProviderConfigurationError",
            "PermissionDeniedError"
        ],
        "BadgeApplicable": [
            "Community"
        ],
        "BadgeCreationError": [
            "BadgeCreateError",
            "BadgeFormulaError",
            "BadgeIconError",
            "BadgeIconInvalidExtensionError",
            "BadgeSetNotFoundError",
            "BadgeTitleError",
            "DisallowedImageFormat",
            "GreaterThanMaxValueError",
            "UploadTooLarge"
        ],
        "BadgeUpdatingError": [
            "BadgeFormulaError",
            "BadgeIconError",
            "BadgeIconInvalidExtensionError",
            "BadgeNotFoundError",
            "BadgeSetNotFoundError",
            "BadgeTitleError",
            "BadgeUpdateError",
            "DisallowedImageFormat",
            "GreaterThanMaxValueError",
            "UploadTooLarge"
        ],
        "BanCreationError": [
            "BulkActionsError",
            "CreateBanError"
        ],
        "Board": [
            "Blog",
            "Forum",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "BoardContainer": [
            "Category",
            "Community",
            "GroupHub"
        ],
        "BoardEventModelEntity": [
            "Blog",
            "Forum",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "BooleanCustomFormField": [
            "CheckField"
        ],
        "BulkUsersImportToRolesError": [
            "IllegalCharsetNameError",
            "InvalidFileError"
        ],
        "CWAAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CWAApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CancelInviteError": [
            "InvalidEmailFormatError",
            "MembershipActionNotAllowed",
            "MembershipInviteNotFound",
            "SendInvitesNullError"
        ],
        "CaseEscalationAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CaseEscalationApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CasePortalAdministrative": [
            "Community"
        ],
        "CasePortalApplicable": [
            "Community"
        ],
        "CategoryContainer": [
            "Category",
            "Community"
        ],
        "ChangeUserPasswordError": [
            "AccountLockedOutError",
            "ChangePasswordError",
            "GreaterThanMaxValueError",
            "LessThanMinValueError",
            "MinimumDigitError",
            "MinimumLowercaseError",
            "MinimumUppercaseError",
            "MustNotHaveAnyHtmlError",
            "RepeatedCharacterSequenceError",
            "ValidationError"
        ],
        "ChildNode": [
            "Blog",
            "Category",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "ClearAllTemporaryOverridesError": [
            "PermissionDeniedError"
        ],
        "CloneRoleError": [
            "DuplicateRoleError",
            "GreaterThanMaxValueError",
            "MustNotHaveAnyHtmlError",
            "NotAllowedToCloneGroupHubRolesError",
            "RequiredFieldError",
            "RoleToCloneDoesNotExistError"
        ],
        "CloseUserAccountError": [
            "IncorrectPassword",
            "PasswordMissingError",
            "PermissionDeniedError",
            "UserNotFoundError"
        ],
        "CommunityGuideLinesErrors": [
            "LanguageCodeNotAllowedError",
            "PermissionDeniedError"
        ],
        "CommunitySalesforceAdministrative": [
            "Community"
        ],
        "CommunitySalesforceApplicable": [
            "Community"
        ],
        "ComponentDefinition": [
            "Component"
        ],
        "ComponentRender": [
            "Component"
        ],
        "ComponentResolve": [
            "Component"
        ],
        "ComponentTemplateDefinition": [
            "ComponentTemplate"
        ],
        "ComponentTemplateError": [
            "ComponentTemplateContentCannotBeSavedError",
            "ComponentTemplateNotFoundError",
            "CreateOrUpdateComponentTemplateFailedError",
            "InvalidComponentTemplateIdError",
            "NoComponentsError",
            "NoDefaultComponentError",
            "UnsupportedMarkupLanguageError"
        ],
        "ComponentTemplateWithIdError": [
            "ComponentTemplateContentCannotBeSavedError",
            "ComponentTemplateNotFoundError",
            "CreateOrUpdateComponentTemplateFailedError"
        ],
        "Connection": [
            "AbuseReportConnection",
            "AbuseReportedMessagesConnection",
            "AbuseReportedPrivateMessagesConnection",
            "AbuseReportedUsersConnection",
            "AgeOfIdeasChartDataConnection",
            "AnonymousUserConnection",
            "ArchivedMessageConnection",
            "AsyncReportsConnection",
            "AttachmentConnection",
            "AttachmentSearchConnection",
            "BadgeConnection",
            "BadgeSetConnection",
            "BlogBoardReportConnection",
            "BlogPostsReportConnection",
            "BoardConnection",
            "CategoryConnection",
            "CategoryReportConnection",
            "ChartDataConnection",
            "CoreNodeConnection",
            "EmailInviteConnection",
            "FilterEventsConnection",
            "FollowConnection",
            "ForumBoardReportConnection",
            "ForumDiscussionsReportConnection",
            "GroupHubConnection",
            "GroupHubReportConnection",
            "HelpfulnessConnection",
            "IdeaBoardReportConnection",
            "IdeaStatusDataConnection",
            "IdeasByStatusesChartDataConnection",
            "IdeasReportConnection",
            "IdeasStatusChangeTrendChartDataConnection",
            "IdeasStatusSetChangeTrendChartDataConnection",
            "InviteConnection",
            "JourneyOfIdeasChartDataConnection",
            "LeadUpToEventChartDataConnection",
            "MailTemplateConnection",
            "MemberReportConnection",
            "MembersReportConnection",
            "MembershipRequestConnection",
            "MessageConnection",
            "MessageDraftHistoryConnection",
            "MessageSearchConnection",
            "MetricConnection",
            "MetricDrillDownByPlacesConnection",
            "MetricDrillDownConnection",
            "NewTopicsByRepliesReportConnection",
            "NodeSearchConnection",
            "NotificationConnection",
            "OccasionBoardReportConnection",
            "OccasionInviteConnection",
            "OccasionsReportConnection",
            "PageViewsDrillDownReportConnection",
            "PlusOneConnection",
            "PostsReportConnection",
            "ProductCategoryConnection",
            "ProductConnection",
            "QuickMessageSearchConnection",
            "RankConnection",
            "RatingConnection",
            "RedirectRulesConnection",
            "RejectedPrivateMessagesConnection",
            "RelatedContentConnection",
            "RevisionConnection",
            "RoleConnection",
            "SalesforceCasesConnection",
            "SolutionDataConnection",
            "SpamConnection",
            "TKBArticlesReportConnection",
            "TKBBoardReportConnection",
            "TrafficMetricDrillDownByPlacesConnection",
            "TrafficMetricDrillDownConnection",
            "TrendingTopicsByRepliesReportConnection",
            "UserConnection",
            "UserSearchConnection",
            "VisitsByReferrersChartDataConnection"
        ],
        "ContainerNode": [
            "Category",
            "Community",
            "GroupHub"
        ],
        "ContentArchiveAdministrative": [
            "Community"
        ],
        "ContentArchiveApplicable": [
            "Community"
        ],
        "CookieAdministrative": [
            "Community"
        ],
        "CookieApplicable": [
            "Community"
        ],
        "CopyFilesError": [
            "CopyFilesFailedError",
            "DestinationFileAlreadyExistsError",
            "FileDoesNotExistError"
        ],
        "CoreNode": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CoreNodeError": [
            "CoreNodeNotFoundError"
        ],
        "CoreNodeEventModelEntity": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CreateChapterError": [
            "GreaterThanMaxValueError",
            "GuideNotEnabledError",
            "InvalidChapterTitle",
            "InvalidContentError",
            "InvalidGuideError",
            "MaximumEntriesAdded",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "CreateFilterErrors": [
            "AddingFilterWordsError",
            "FilterAlreadyExistsError",
            "InsufficientPermissionsForUser"
        ],
        "CreateFollowError": [
            "BothIncludesAndExcludesNotAllowed",
            "EmailVerificationRequired",
            "InvalidFollow",
            "NoSuchNode",
            "ObjectNotFoundException",
            "ResourceNotFound"
        ],
        "CreateGroupHubRoleError": [
            "DuplicateRoleError",
            "GreaterThanMaxValueError",
            "MustNotHaveAnyHtmlError",
            "NotAllowedToCreateGroupHubRolesForBoardsError",
            "RequiredFieldError"
        ],
        "CreateGuideError": [
            "DisallowedImageFormat",
            "GreaterThanMaxValueError",
            "GuideNotEnabledError",
            "InvalidCropProps",
            "InvalidGuideError",
            "InvalidGuideTitle",
            "MaximumEntriesAdded",
            "ParentNodeError",
            "PermissionDeniedError",
            "TooManyUploadedImages",
            "UnsupportedConversationStyleError",
            "UploadFailed",
            "UploadLimitReached",
            "UploadTooLarge"
        ],
        "CreateIdeaStatusError": [
            "PermissionDeniedError",
            "StatusKeyDeletedError",
            "StatusKeyExistsError",
            "TextContainsEmojisError"
        ],
        "CreateNodeError": [
            "CannotSetRequireTagsError",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "DuplicateNodeId",
            "DuplicateTagError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "IdMustBeAlphanumeric",
            "InvalidCustomFieldValueError",
            "InvalidNodeAvatar",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MustNotHaveAnyHtmlError",
            "NotValidPossibleValueError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldError",
            "ValidateUnsafeCharError",
            "ValidationError"
        ],
        "CreateOccasionInviteError": [
            "CannotParseInputError",
            "EmailInviteNotEnabledError",
            "InviteLimitReachedError",
            "OccasionEndedError",
            "OccasionNotFoundError",
            "PermissionDeniedError"
        ],
        "CreateOrUpdateAssetFromDownloadedImageError": [
            "AssetAlreadyExistsError",
            "DisallowedImageFormat",
            "ImageValidationFailed",
            "InvalidAssetDirectoryNameError",
            "InvalidAssetNameError",
            "MalformedUrl",
            "NoFileUploaded",
            "TooManyUploadedImages",
            "UnsplashDataNotProvided",
            "UploadFailed",
            "UploadLimitReached",
            "UploadTooLarge"
        ],
        "CreateOrUpdateAssetFromUploadError": [
            "AssetAlreadyExistsError",
            "DisallowedImageFormat",
            "InvalidAssetDirectoryNameError",
            "InvalidAssetNameError",
            "NoFileUploaded",
            "TooManyUploadedImages",
            "UploadFailed",
            "UploadLimitReached",
            "UploadTooLarge"
        ],
        "CreateOrUpdateComponentTemplateError": [
            "ComponentTemplateContentCannotBeSavedError",
            "CreateOrUpdateComponentTemplateFailedError",
            "InvalidComponentTemplateIdError",
            "NoComponentsError",
            "NoDefaultComponentError",
            "UnsupportedMarkupLanguageError",
            "ValidationError"
        ],
        "CreateOrUpdateCustomFieldDefinitionsError": [
            "CreateOrUpdateCustomFieldDefinitionFailedError",
            "CreateOrUpdateCustomFieldsEntityDefinitionFailedError"
        ],
        "CreateOrUpdateFormError": [
            "CreateOrUpdateFormFailedError",
            "FormNotFoundError",
            "InvalidFormFieldsError",
            "InvalidGitCommitInfoHeaderError",
            "RequiredFieldNotSetError"
        ],
        "CreateOrUpdateOpenIdConnectSelfServiceIdpErrors": [
            "FeatureIsDisabledError",
            "GreaterThanMaxValueError",
            "IdpCreationError",
            "InsufficientPermissionsForUser",
            "MustBeAlphanumericError",
            "MustNotHaveAnyHtmlError",
            "ValidationError"
        ],
        "CreateOrUpdatePageError": [
            "CreateOrUpdatePageFailedError"
        ],
        "CreateOrUpdatePageScriptDefinitionError": [
            "CreateOrUpdatePageScriptDefinitionFailedError",
            "DuplicatePageScriptIdError",
            "DuplicatePageScriptProviderIdError",
            "PageScriptProviderIdAlreadyExistsError"
        ],
        "CreateOrUpdateQuiltError": [
            "CoreNodeNotFoundError",
            "CreateOrUpdateQuiltFailedError",
            "CreateOrUpdateQuiltWrapperFailedError",
            "CreateOrUpdateTextFailedError",
            "EmptyQuiltWrapperIdError",
            "FeaturedContentWidgetDataNotUpdatedError",
            "FeaturedPlacesWidgetDataNotUpdatedError",
            "FeaturedWidgetNotFoundError",
            "GreaterThanMaxValueError",
            "InvalidCoreNodeTypeForScopeError",
            "InvalidCustomQuiltIdError",
            "InvalidDefaultQuiltIdError",
            "InvalidInputError",
            "InvalidMessageError",
            "InvalidNodeTypeError",
            "InvalidQuiltError",
            "InvalidQuiltWrapperError",
            "LanguageNotEnabled",
            "MessageNotFoundError",
            "PermissionDeniedError",
            "QuiltNotFoundError",
            "QuiltWrapperNotFoundError",
            "TextFileNotFoundError",
            "TextForComponentNotFoundError",
            "TextNotFoundError"
        ],
        "CreateOrUpdateTemporaryComponentTemplateError": [
            "ComponentTemplateContentCannotBeSavedError",
            "CreateOrUpdateComponentTemplateFailedError",
            "InvalidComponentTemplateIdError",
            "NoComponentsError",
            "UnsupportedMarkupLanguageError"
        ],
        "CreateOrUpdateTemporaryCustomFieldDefinitionsError": [
            "CreateOrUpdateCustomFieldDefinitionFailedError",
            "CreateOrUpdateCustomFieldsEntityDefinitionFailedError"
        ],
        "CreateOrUpdateTemporaryCustomQuiltError": [
            "InvalidCustomQuiltIdError",
            "InvalidQuiltError",
            "PermissionDeniedError"
        ],
        "CreateOrUpdateTemporaryEndpointError": [
            "CreateOrUpdateEndpointFailedError",
            "InvalidEndpointIdError"
        ],
        "CreateOrUpdateTemporaryFormError": [
            "FormNotFoundError",
            "InvalidFormFieldsError",
            "RequiredFieldNotSetError"
        ],
        "CreateOrUpdateTemporaryQuiltOverridesError": [
            "CreateOrUpdateQuiltFailedError",
            "InvalidDefaultQuiltIdError",
            "QuiltNotFoundError"
        ],
        "CreateOrUpdateTemporaryTextOverrideError": [
            "CreateOrUpdateTextFailedError"
        ],
        "CreateOrUpdateTemporaryThemeOverridesError": [
            "BaseThemeNotFoundError",
            "CreateOrUpdateThemeFailedError",
            "ThemeAlreadyExistsError",
            "ThemeNotFoundError"
        ],
        "CreateOrUpdateTemporaryWrapperOverridesError": [
            "QuiltWrapperNotFoundError"
        ],
        "CreateOrUpdateTextError": [
            "CreateOrUpdateTextFailedError",
            "LanguageNotEnabled"
        ],
        "CreateOrUpdateThemeError": [
            "BaseThemeNotFoundError",
            "CoreNodeNotFoundError",
            "CreateOrUpdateThemeFailedError",
            "InvalidFontNameError",
            "InvalidGitCommitInfoHeaderError",
            "MustBeAlphanumericError",
            "QuiltNotFoundError",
            "RequiredFieldError",
            "ThemeAlreadyExistsError",
            "ThemeNotFoundError"
        ],
        "CreatePrivateNotesError": [
            "PrivateConversationCreation",
            "PrivateConversationLimitReachedError",
            "PrivateNoteFilterError"
        ],
        "CreateRedirectRuleErrors": [
            "InsufficientPermissionsForUser",
            "RedirectRuleInvalidCommunityUrlError",
            "RedirectRuleSrcUrlEqDestUrlError",
            "RedirectRuleUrlAlreadyExistsError"
        ],
        "CreateReleaseTagError": [
            "ReleaseTagAlreadyExistsError"
        ],
        "CreateRoleError": [
            "DuplicateRoleError",
            "GreaterThanMaxValueError",
            "MustNotHaveAnyHtmlError",
            "NotAllowedToCreateGroupHubRolesError",
            "RequiredFieldError"
        ],
        "CreateRsvpResponseError": [
            "RsvpOccasionValidationError",
            "RsvpResponseValidationError"
        ],
        "CreateUploadedImageError": [
            "DisallowedImageFormat",
            "InvalidUriError",
            "MalformedUrl",
            "NoFileUploaded",
            "NotValidPossibleValueError",
            "TooManyUploadedImages",
            "UnsplashDataNotProvided",
            "UploadFailed",
            "UploadLimitReached",
            "UploadTooLarge",
            "UserNotRegistered"
        ],
        "CreateUserError": [
            "BannedEmail",
            "BannedLogin",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "DuplicateEmail",
            "DuplicateLoginWithSuggestion",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "InvalidCustomFieldValueError",
            "InvalidEmailAddressError",
            "InvalidLoginValue",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MinimumDigitError",
            "MinimumLowercaseError",
            "MinimumUppercaseError",
            "MustBeAlphanumericError",
            "MustNotHaveAnyHtmlError",
            "NotValidPossibleValueError",
            "PermissionDeniedError",
            "RepeatedCharacterSequenceError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldNotSetError",
            "SameLogin",
            "ValidationError"
        ],
        "CreateVideoError": [
            "CreateVideoFailedError",
            "VideoUploadLimitError"
        ],
        "CustomField": [
            "CustomBooleanField",
            "CustomDateTimeField",
            "CustomFloatField",
            "CustomFloatListField",
            "CustomIntField",
            "CustomIntListField",
            "CustomLongField",
            "CustomStringField",
            "CustomStringListField"
        ],
        "CustomFieldAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CustomFieldApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CustomFieldDefinitionError": [
            "CreateOrUpdateCustomFieldDefinitionFailedError",
            "CustomFieldDefinitionNotFoundError"
        ],
        "CustomFieldError": [],
        "CustomFieldForEntityError": [
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotRemovable",
            "CustomFieldNotSettable",
            "InvalidCustomFieldValueError",
            "RequiredCustomFieldNotSet"
        ],
        "CustomFieldListValueDefinition": [
            "FloatListCustomFieldValueDefinition",
            "IntListCustomFieldValueDefinition",
            "StringListCustomFieldValueDefinition"
        ],
        "CustomFieldQueryConstraintDefinition": [
            "BooleanCustomFieldQueryConstraintDefinition",
            "DateTimeCustomFieldQueryConstraintDefinition",
            "FloatCustomFieldQueryConstraintDefinition",
            "IntCustomFieldQueryConstraintDefinition",
            "LongCustomFieldQueryConstraintDefinition",
            "StringCustomFieldQueryConstraintDefinition"
        ],
        "CustomFieldQueryDefinition": [
            "BooleanCustomFieldQueryDefinition",
            "DateTimeCustomFieldQueryDefinition",
            "FloatCustomFieldQueryDefinition",
            "IntCustomFieldQueryDefinition",
            "LongCustomFieldQueryDefinition",
            "StringCustomFieldQueryDefinition"
        ],
        "CustomFieldSingleValueDefinition": [
            "BooleanCustomFieldValueDefinition",
            "DateTimeCustomFieldValueDefinition",
            "FloatCustomFieldValueDefinition",
            "IntCustomFieldValueDefinition",
            "LongCustomFieldValueDefinition",
            "StringCustomFieldValueDefinition"
        ],
        "CustomFieldValueDefinition": [
            "BooleanCustomFieldValueDefinition",
            "DateTimeCustomFieldValueDefinition",
            "FloatCustomFieldValueDefinition",
            "FloatListCustomFieldValueDefinition",
            "IntCustomFieldValueDefinition",
            "IntListCustomFieldValueDefinition",
            "LongCustomFieldValueDefinition",
            "StringCustomFieldValueDefinition",
            "StringListCustomFieldValueDefinition"
        ],
        "CustomFieldsCoreNodeEntity": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "CustomFieldsEntity": [
            "AcceptedSolutionMessage",
            "Blog",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "Category",
            "Community",
            "Forum",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "GroupHub",
            "Idea",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "MessageAutosaveData",
            "Occasion",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "Qanda",
            "SalesforceCase",
            "Tkb",
            "TkbReplyMessage",
            "TkbTopicMessage",
            "User"
        ],
        "CustomFieldsEntityDefinitionError": [
            "CreateOrUpdateCustomFieldsEntityDefinitionFailedError",
            "CustomFieldsEntityDefinitionNotFoundError"
        ],
        "DateTimeCustomFormField": [
            "DateTimeField",
            "DateTimeInputField"
        ],
        "DeleteAnonymousUserErrors": [
            "EmptyAnonymousUserDataError",
            "GreaterThanMaxValueError",
            "IncorrectPassword",
            "InvalidEmailAddressError",
            "LessThanMinValueError",
            "PermissionDeniedError",
            "ValidationError"
        ],
        "DeleteBoardError": [
            "PermissionDeniedError"
        ],
        "DeleteCancelEmailInviteError": [
            "EmailAddressNotInvitedError",
            "PermissionDeniedError"
        ],
        "DeleteCategoryError": [
            "PermissionDeniedError"
        ],
        "DeleteChapterArticleError": [
            "GuideNotEnabledError",
            "InvalidArticleError",
            "InvalidChapterError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "DeleteComponentTemplateError": [
            "ComponentTemplateNotFoundError"
        ],
        "DeleteCustomFieldDefinitionsError": [
            "CustomFieldDefinitionNotFoundError",
            "CustomFieldsEntityDefinitionNotFoundError"
        ],
        "DeleteCustomQuiltError": [
            "InvalidCustomQuiltIdError",
            "PermissionDeniedError"
        ],
        "DeleteFilterErrors": [
            "FilterDoesNotExistError",
            "InsufficientPermissionsForUser"
        ],
        "DeleteFollowError": [
            "EmailVerificationRequired",
            "InvalidFollow",
            "NoSuchNode",
            "ObjectNotFoundException"
        ],
        "DeleteFormError": [
            "FormNotFoundError"
        ],
        "DeleteGroupHubError": [
            "PermissionDeniedError"
        ],
        "DeleteGuideContentError": [
            "GuideNotEnabledError",
            "InvalidArticleError",
            "InvalidChapterError",
            "InvalidContentError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "DeleteGuideError": [
            "GuideNotEnabledError",
            "InvalidGuideError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "DeleteIpAddressesError": [
            "GdprNotEnabledInCommunityError",
            "NoIpsAddressesRecordedError",
            "PermissionDeniedError"
        ],
        "DeleteManuallySortedArticlesError": [
            "InvalidNodeError",
            "PermissionDeniedError"
        ],
        "DeleteOpenIdConnectSelfServiceIdpErrors": [
            "FeatureIsDisabledError",
            "IdpDeletionError",
            "IdpDoesNotExistError",
            "InsufficientPermissionsForUser"
        ],
        "DeletePageScriptDefinitionError": [
            "PageScriptDefinitionNotFoundError"
        ],
        "DeletePrivateConversationError": [
            "PermissionDeniedError"
        ],
        "DeleteQuiltNodeScopeError": [
            "PermissionDeniedError",
            "RequiredFieldNotSetError"
        ],
        "DeleteQuiltOverrideError": [
            "PermissionDeniedError",
            "ReplacementQuiltNotFoundError"
        ],
        "DeleteRedirectRuleErrors": [
            "InsufficientPermissionsForUser",
            "RedirectRuleDoesNotExistError"
        ],
        "DeleteRsvpResponseError": [
            "RsvpOccasionValidationError",
            "RsvpResponseValidationError"
        ],
        "DeleteRuleError": [
            "InvalidRuleId"
        ],
        "DeleteRuleIdError": [
            "InvalidRuleId"
        ],
        "DeleteTemporaryComponentTemplateError": [
            "ComponentTemplateNotFoundError"
        ],
        "DeleteTemporaryCustomFieldDefinitionsError": [
            "CustomFieldDefinitionNotFoundError",
            "CustomFieldsEntityDefinitionNotFoundError"
        ],
        "DeleteTemporaryCustomQuiltError": [
            "InvalidCustomQuiltIdError",
            "PermissionDeniedError"
        ],
        "DeleteTemporaryEndpointError": [
            "EndpointNotFoundError"
        ],
        "DeleteTemporaryFormsError": [
            "ReplacementFormNotFoundError"
        ],
        "DeleteTemporaryQuiltOverridesError": [
            "ReplacementQuiltNotFoundError"
        ],
        "DeleteTemporaryTextOverrideError": [
            "TextFileNotFoundError",
            "TextForComponentNotFoundError",
            "TextNotFoundError"
        ],
        "DeleteTemporaryThemeOverridesError": [
            "ReplacementThemeNotFoundError",
            "ThemeNotFoundError"
        ],
        "DeleteTemporaryWrapperOverridesError": [
            "QuiltWrapperNotFoundError"
        ],
        "DeleteThemeError": [
            "ReplacementThemeNotFoundError",
            "ThemeNotFoundError"
        ],
        "DeleteThemeQuiltScopeError": [
            "PermissionDeniedError",
            "RequiredFieldNotSetError"
        ],
        "DevBranchAdministrative": [
            "Community"
        ],
        "DevBranchApplicable": [
            "Community"
        ],
        "DeveloperAccessTokenError": [
            "AccessTokenCreationFailedError",
            "FeatureNotConfiguredError",
            "NoInternalApiAppError",
            "PermissionDeniedError",
            "RequiredFieldNotSetError",
            "UserNotRegistered"
        ],
        "Discussable": [
            "BlogReplyMessage",
            "BlogTopicMessage",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "Product",
            "TkbReplyMessage",
            "TkbTopicMessage"
        ],
        "Edge": [
            "AbuseReportEdge",
            "AbuseReportedMessageEdge",
            "AbuseReportedPrivateMessageEdge",
            "AbuseReportedUserEdge",
            "AgeOfIdeasChartDataEdge",
            "AnonymousUserEdge",
            "ArchivedMessageEdge",
            "ArticleEdge",
            "AssociatedImageEdge",
            "AsyncReportEdge",
            "AttachmentEdge",
            "AttachmentSearchEdge",
            "AuditLogEdge",
            "BadgeEdge",
            "BadgeSetEdge",
            "BanEdge",
            "BlogBoardReportEdge",
            "BlogPostsReportEdge",
            "BoardEdge",
            "CategoryEdge",
            "CategoryReportEdge",
            "ChapterArticleEdge",
            "ChartDataEdge",
            "ContentEdge",
            "CoreNodeEdge",
            "EmailInviteEdge",
            "FilterEventEdge",
            "FollowEdge",
            "ForumBoardReportEdge",
            "ForumDiscussionsReportEdge",
            "GroupHubEdge",
            "GroupHubReportEdge",
            "GuideEdge",
            "HelpfulnessEdge",
            "IdeaBoardReportEdge",
            "IdeaStatusDataEdge",
            "IdeasByStatusesChartDataEdge",
            "IdeasReportEdge",
            "IdeasStatusChangeTrendChartDataEdge",
            "IdeasStatusSetChangeTrendChartDataEdge",
            "ImageEdge",
            "InviteEdge",
            "JourneyOfIdeasChartDataEdge",
            "KudoEdge",
            "LeadUpToEventChartDataEdge",
            "MailTemplateEdge",
            "MemberReportEdge",
            "MembersReportEdge",
            "MembershipRequestEdge",
            "MessageDraftHistoryEdge",
            "MessageEdge",
            "MessageSearchEdge",
            "MetricDrillDownByPlacesEdge",
            "MetricDrillDownEdge",
            "MetricEdge",
            "NewTopicsByRepliesReportEdge",
            "NodeSearchEdge",
            "NotificationEdge",
            "OccasionBoardReportEdge",
            "OccasionInviteEdge",
            "OccasionsReportEdge",
            "PageViewDrillDownReportEdge",
            "PlusOneEdge",
            "PostsReportEdge",
            "PrivateConversationEdge",
            "PrivateNoteEdge",
            "ProductCategoryEdge",
            "ProductEdge",
            "QuickMessageSearchEdge",
            "RankEdge",
            "RatingEdge",
            "RedirectRuleEdge",
            "RejectedPrivateMessageEdge",
            "RelatedContentEdge",
            "RevisionEdge",
            "RoleEdge",
            "RsvpEdge",
            "SalesforceCaseEdge",
            "SolutionDataEdge",
            "SpamEdge",
            "TKBArticlesReportEdge",
            "TKBBoardReportEdge",
            "TagEdge",
            "TrafficMetricDrillDownByPlacesEdge",
            "TrafficMetricDrillDownEdge",
            "TrendingTopicsByRepliesReportEdge",
            "UserEdge",
            "UserSearchEdge",
            "VideoEdge",
            "VisitsByReferrersChartDataEdge"
        ],
        "EditFilterErrors": [
            "FilterDoesNotExistError",
            "InsufficientPermissionsForUser"
        ],
        "EditIdeaStatusError": [
            "PermissionDeniedError",
            "TextContainsEmojisError"
        ],
        "EditorAssetContext": [
            "QuiltEditorQuiltTemplateContextAssets"
        ],
        "EmailAdministrative": [
            "Community"
        ],
        "EmojiAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "EmojiApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "EmojiUserAdministrative": [
            "User"
        ],
        "EmojiUserApplicable": [
            "User"
        ],
        "EndpointAdministrative": [
            "Community"
        ],
        "EndpointApplicable": [
            "Community"
        ],
        "EndpointError": [
            "CreateOrUpdateEndpointFailedError",
            "EndpointNotFoundError",
            "InvalidEndpointIdError"
        ],
        "EndpointWithIdError": [
            "CreateOrUpdateEndpointFailedError",
            "EndpointNotFoundError"
        ],
        "Entity": [
            "AcceptedSolutionMessage",
            "Blog",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "Category",
            "Community",
            "Follow",
            "Forum",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "GroupHub",
            "Idea",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "MessageAutosaveData",
            "Occasion",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "Qanda",
            "SalesforceCase",
            "Tkb",
            "TkbReplyMessage",
            "TkbTopicMessage",
            "User"
        ],
        "EntityCustomFormField": [
            "BooleanEntityCustomFormField",
            "DateTimeEntityCustomFormField",
            "FloatEntityCustomFormField",
            "IntEntityCustomFormField",
            "ListFloatEntityCustomFormField",
            "ListIntEntityCustomFormField",
            "ListStringEntityCustomFormField",
            "LongEntityCustomFormField",
            "StringEntityCustomFormField"
        ],
        "Error": [
            "AccessTokenCreationFailedError",
            "AccessTokenRevokeFailedError",
            "AccountLockedOutError",
            "AddAdminNoteError",
            "AddArticleError",
            "AddHelpfulnessToTKBMessageFailedError",
            "AddPlusOneToMessageFailedError",
            "AddRatingToMessageFailedError",
            "AddTagLimitReachedError",
            "AddTagToMessageFailedError",
            "AddingFilterWordsError",
            "AlreadyArchivedMessageError",
            "AppNotFoundError",
            "ArchivalFeatureNotEnabledError",
            "AssetAlreadyExistsError",
            "AssetDoesNotExistError",
            "AttachmentContentTypeNotSpecifiedError",
            "AttachmentCreateFailedError",
            "AttachmentDeleteFailedError",
            "AttachmentFileNameNotSpecifiedError",
            "AuthServiceRemoteError",
            "BadgeCreateError",
            "BadgeDeleteError",
            "BadgeFormulaError",
            "BadgeIconError",
            "BadgeIconInvalidExtensionError",
            "BadgeNotFoundError",
            "BadgeSetCreateError",
            "BadgeSetDeleteError",
            "BadgeSetError",
            "BadgeSetNotFoundError",
            "BadgeSetUpdateError",
            "BadgeTitleError",
            "BadgeUpdateError",
            "BannedEmail",
            "BannedLogin",
            "BaseThemeNotFoundError",
            "BothIncludesAndExcludesNotAllowed",
            "BranchDoesNotExistsError",
            "BulkActionsError",
            "CannotParseInputError",
            "CannotResetBranchError",
            "CannotSetRequireTagsError",
            "CategoryAssociatedToLocaleError",
            "CategoryIsDefaultForLocaleError",
            "ChangePasswordError",
            "ClientCredentialsNotEnabledError",
            "ClosedCaptionError",
            "ComponentTemplateContentCannotBeSavedError",
            "ComponentTemplateNotFoundError",
            "CopyFilesFailedError",
            "CoreNodeNotFoundError",
            "CreateBanError",
            "CreateMessageAutosaveError",
            "CreateOrUpdateComponentTemplateFailedError",
            "CreateOrUpdateCustomFieldDefinitionFailedError",
            "CreateOrUpdateCustomFieldsEntityDefinitionFailedError",
            "CreateOrUpdateEndpointFailedError",
            "CreateOrUpdateFormFailedError",
            "CreateOrUpdatePageFailedError",
            "CreateOrUpdatePageScriptDefinitionFailedError",
            "CreateOrUpdateQuiltFailedError",
            "CreateOrUpdateQuiltWrapperFailedError",
            "CreateOrUpdateTextFailedError",
            "CreateOrUpdateThemeFailedError",
            "CreateVideoFailedError",
            "CustomFieldDefinitionNotFoundError",
            "CustomFieldEscalationSettingError",
            "CustomFieldNameNotUniqueError",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotRemovable",
            "CustomFieldNotSettable",
            "CustomFieldsEntityDefinitionNotFoundError",
            "DateMustNotHaveCapitalYError",
            "DateMustNotHaveTimeFormatError",
            "DefaultError",
            "DeleteMessageAutosaveError",
            "DeleteRoleError",
            "DeleteTagFollowError",
            "DeleteTagFromNodeError",
            "DeleteTagStatusForNodeError",
            "DestinationFileAlreadyExistsError",
            "DisallowedImageFormat",
            "DuplicateEmail",
            "DuplicateGroupHubTitle",
            "DuplicateKBArticleError",
            "DuplicateLogin",
            "DuplicateLoginWithSuggestion",
            "DuplicateNodeId",
            "DuplicatePageScriptIdError",
            "DuplicatePageScriptProviderIdError",
            "DuplicateRoleError",
            "DuplicateTagError",
            "DuplicatedSSOIdError",
            "EditTagsOnNodeError",
            "EmailAddressAlreadyExistsError",
            "EmailAddressAlreadyInvitedError",
            "EmailAddressNotInvitedError",
            "EmailInviteNotEnabledError",
            "EmailVerificationRequired",
            "EmptyAnonymousUserDataError",
            "EmptyQuiltWrapperIdError",
            "EmptyTitleError",
            "EndpointNotFoundError",
            "EntityAlreadyIgnoredAsNotAbuseError",
            "EntityAlreadyModeratedError",
            "EntityAlreadyRejectedAsAbuseError",
            "EntityNotRejectedAsAbuseError",
            "EntityNotReportedAsAbuseError",
            "EntityNotReportedError",
            "ExpiredInviteTokenError",
            "FeatureIsDisabledError",
            "FeatureNotConfiguredError",
            "FeaturedContentWidgetDataNotUpdatedError",
            "FeaturedPlacesWidgetDataNotUpdatedError",
            "FeaturedWidgetNotFoundError",
            "FileDoesNotExistError",
            "FileNotSpecifiedError",
            "FilterAlreadyExistsError",
            "FilterDoesNotExistError",
            "FloodLimitError",
            "FormAlreadyExistsError",
            "FormNotFoundError",
            "FreezeEditsAlreadySetError",
            "GdprNotEnabledInCommunityError",
            "GithubNotEnabledError",
            "GiveKudoToMessageFailedError",
            "GiveKudoToMessageLimitReachedError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "GroupHubBoardIdSmutError",
            "GroupHubBoardNameSmutError",
            "GroupHubBoardNotProvidedError",
            "GroupHubDescriptionSmutError",
            "GroupHubIdSmutError",
            "GroupHubSubNodesDuplicateId",
            "GroupHubTitleSmutError",
            "GuideNotEnabledError",
            "HasInvalidHtmlTagError",
            "HtmlStrippedError",
            "IdMustBeAlphanumeric",
            "IdeaBoardNotFoundError",
            "IdpCreationError",
            "IdpDeletionError",
            "IdpDoesNotExistError",
            "IgnoreReportedEventFailedError",
            "IllegalCharsetNameError",
            "ImageValidationFailed",
            "IncorrectPassword",
            "IncorrectProviderConfigurationSizeError",
            "InputFieldsMissingError",
            "InsufficientPermissionsForUser",
            "InvalidAbuseReportReasonError",
            "InvalidAbuseReportReportedForError",
            "InvalidArticleError",
            "InvalidAssetDirectoryNameError",
            "InvalidAssetNameError",
            "InvalidCategoryAssociationError",
            "InvalidCategoryError",
            "InvalidChapterError",
            "InvalidChapterTitle",
            "InvalidComponentTemplateIdError",
            "InvalidContentError",
            "InvalidConversationTypeError",
            "InvalidCoreNodeTypeForScopeError",
            "InvalidCropProps",
            "InvalidCustomFieldValueError",
            "InvalidCustomQuiltIdError",
            "InvalidDefaultQuiltIdError",
            "InvalidDestinationError",
            "InvalidEmailAddressError",
            "InvalidEmailError",
            "InvalidEmailFormatError",
            "InvalidEndpointIdError",
            "InvalidFileError",
            "InvalidFollow",
            "InvalidFontNameError",
            "InvalidFormFieldsError",
            "InvalidFormParseError",
            "InvalidGitCommitInfoHeaderError",
            "InvalidGuideError",
            "InvalidGuideTitle",
            "InvalidHtmlError",
            "InvalidInputError",
            "InvalidInviteTokenError",
            "InvalidLanguageError",
            "InvalidLocaleAssociationError",
            "InvalidLoginValue",
            "InvalidMessageError",
            "InvalidMessageId",
            "InvalidMoveAfterNodeParentMismatchError",
            "InvalidMoveAfterNodeTypeMismatchError",
            "InvalidNodeAvatar",
            "InvalidNodeError",
            "InvalidNodeLevelPermissionsError",
            "InvalidNodeTypeError",
            "InvalidPositionSpecifiedError",
            "InvalidPrivateConversationError",
            "InvalidProviderConfigurationError",
            "InvalidQuiltError",
            "InvalidQuiltIdError",
            "InvalidQuiltWrapperError",
            "InvalidRole",
            "InvalidRuleId",
            "InvalidSettingValueError",
            "InvalidStatusKeyError",
            "InvalidTargetNodeForUnarchivalError",
            "InvalidUriError",
            "InvalidUrlError",
            "InvalidUserAvatar",
            "InvalidUserPropertyError",
            "InviteLimitReachedError",
            "KeywordEmptyError",
            "LanguageCodeNotAllowedError",
            "LanguageNotAllowed",
            "LanguageNotEnabled",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "LoginCannotBeChangedError",
            "MalformedUrl",
            "ManualSortNotEnabledError",
            "ManuallySortedError",
            "MaxRulesLimitError",
            "MaxWordsLimitError",
            "MaximumEntriesAdded",
            "MediaSnippetError",
            "MembershipActionNotAllowed",
            "MembershipInviteNotFound",
            "MembershipInvitesLimitReached",
            "MembershipNodeNotFound",
            "MembershipNotApproved",
            "MembershipRequestNotFound",
            "MembershipUserNotFound",
            "MessageArchivalFailedError",
            "MessageArchivalQueuedError",
            "MessageBoardNotTkbError",
            "MessageFilterError",
            "MessageNotArchivedError",
            "MessageNotEscalatedError",
            "MessageNotFoundError",
            "MessageReplyArchivalNotAllowedError",
            "MessageReplyUnarchivalNotAllowedError",
            "MessageUnarchivalFailedError",
            "MessageUpdateFailedError",
            "MinimumAgeRequiredError",
            "MinimumDigitError",
            "MinimumLowercaseError",
            "MinimumUppercaseError",
            "MoveAfterNodeNotFound",
            "MoveFromMainBranchNotAllowedError",
            "MoveMessageFailedError",
            "MoveToSameBranchNotAllowedError",
            "MustBeAlphanumericError",
            "MustNotHaveAnyHtmlError",
            "MuteTagFollowError",
            "NoAppConfigError",
            "NoAppError",
            "NoArticlesFoundError",
            "NoComponentsError",
            "NoDefaultComponentError",
            "NoFileUploaded",
            "NoInternalApiAppError",
            "NoIpsAddressesRecordedError",
            "NoOrgNameError",
            "NoParentFrame",
            "NoRepoNameError",
            "NoSuchMessageError",
            "NoSuchNode",
            "NoSuchNodeError",
            "NoSuchRevisionError",
            "NodeMoveFailedError",
            "NonSsoUserError",
            "NotAMember",
            "NotAMembershipNode",
            "NotAllowedToCloneGroupHubRolesError",
            "NotAllowedToCreateGroupHubRolesError",
            "NotAllowedToCreateGroupHubRolesForBoardsError",
            "NotValidDateFormatError",
            "NotValidPossibleValueError",
            "ObjectNotFoundException",
            "OccasionEndedError",
            "OccasionNotFoundError",
            "OccasionValidationError",
            "OperationNotSupportedForEntityError",
            "PageNotFoundError",
            "PageScriptDefinitionNotFoundError",
            "PageScriptProviderIdAlreadyExistsError",
            "ParentNodeError",
            "ParseTemplateError",
            "PasswordMissingError",
            "PermissionDeniedError",
            "PrivateConversationCreation",
            "PrivateConversationLimitReachedError",
            "PrivateConversationNotFoundError",
            "PrivateNoteFilterError",
            "QuiltAlreadyExistsError",
            "QuiltNotFoundError",
            "QuiltTemplateNotFoundError",
            "QuiltWrapperNotFoundError",
            "RankingCreateError",
            "RankingDeleteError",
            "RankingFormulaError",
            "RankingIconError",
            "RankingIconInvalidExtensionError",
            "RankingNameError",
            "RankingRoleError",
            "RankingUpdateError",
            "ReGrantBadgeError",
            "ReadOnlyAlreadySetError",
            "RedirectRuleDoesNotExistError",
            "RedirectRuleInvalidCommunityUrlError",
            "RedirectRuleSrcUrlEqDestUrlError",
            "RedirectRuleUrlAlreadyExistsError",
            "RelatedUrlNotAllowedForRepliesError",
            "ReleaseTagAlreadyExistsError",
            "RemoveBanError",
            "RemoveTagFromMessageFailedError",
            "RemoveZoomIntegrationErrors",
            "RepeatedCharacterSequenceError",
            "ReplaceTagsOnNodeForUserError",
            "ReplacementFormNotFoundError",
            "ReplacementQuiltNotFoundError",
            "ReplacementThemeNotFoundError",
            "RepoNameExistsError",
            "ReportAuthoredNoteError",
            "ReportNoteFloodError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldEmptyError",
            "RequiredFieldError",
            "RequiredFieldNotSetError",
            "ResourceNotFound",
            "RevokeBadgeError",
            "RevokeKudoFromMessageFailedError",
            "RoleNotFoundError",
            "RoleToCloneDoesNotExistError",
            "RsvpOccasionValidationError",
            "RsvpResponseValidationError",
            "RulesOverlapped",
            "SalesforceCaseAttachmentError",
            "SalesforceCaseCloseError",
            "SalesforceCaseCommentError",
            "SalesforceCaseCreateError",
            "SalesforceCaseCreateInternalError",
            "SalesforceCaseFetchError",
            "SalesforceCaseUpdateError",
            "SalesforceMessageEscalationError",
            "SalesforceUserSyncError",
            "SameEmail",
            "SameLogin",
            "SelfRegistrationNotAllowedError",
            "SendEmailError",
            "SendInviteNodeNotFoundError",
            "SendInvitesNullError",
            "SeoTitleExceedsLimit",
            "SetSettingsFailedError",
            "SetUserEmailVerifiedError",
            "SsoFirstAndLastNameUpdateNotAllowedError",
            "StatusKeyDeletedError",
            "StatusKeyExistsError",
            "SwitchUserActionError",
            "TagExistsError",
            "TagFollowError",
            "TagPermissionResponseError",
            "TextContainsEmojisError",
            "TextFileNotFoundError",
            "TextForComponentNotFoundError",
            "TextNotFoundError",
            "ThemeAlreadyExistsError",
            "ThemeNotFoundError",
            "TitleMustNotContainHTML",
            "TooManyUploadedImages",
            "UnsplashDataNotProvided",
            "UnsubscribeFromEmailNotificationsError",
            "UnsupportedContentTypeError",
            "UnsupportedConversationStyleError",
            "UnsupportedMarkupLanguageError",
            "UpdateBanError",
            "UpdateCommunityFailedError",
            "UpdateRolesError",
            "UpdateUserRolesError",
            "UploadFailed",
            "UploadLimitReached",
            "UploadTooLarge",
            "UploadTooSmall",
            "UrlDoesNotExistsError",
            "UrlEmptyError",
            "UrlMustUseHttpOrHttpsError",
            "UserAcceptsTermsOfServiceRequiredError",
            "UserMentionsLimitReachedError",
            "UserNotExistError",
            "UserNotFoundError",
            "UserNotRegistered",
            "UserSettingsFilterError",
            "ValidateUnsafeCharError",
            "ValidationError",
            "VerifyUserEmailFromTokenError",
            "VideoUploadLimitError",
            "VideoUrlProcessError",
            "ZoomAuthorisationError",
            "ZoomMeetingDetailsError"
        ],
        "ErrorWithArgs": [
            "AddTagLimitReachedError",
            "BaseThemeNotFoundError",
            "ComponentTemplateContentCannotBeSavedError",
            "ComponentTemplateNotFoundError",
            "CreateOrUpdateComponentTemplateFailedError",
            "CreateOrUpdateCustomFieldDefinitionFailedError",
            "CreateOrUpdateCustomFieldsEntityDefinitionFailedError",
            "CreateOrUpdateEndpointFailedError",
            "CreateOrUpdateFormFailedError",
            "CreateOrUpdateQuiltFailedError",
            "CreateOrUpdateQuiltWrapperFailedError",
            "CreateOrUpdateThemeFailedError",
            "CustomFieldDefinitionNotFoundError",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotRemovable",
            "CustomFieldNotSettable",
            "CustomFieldsEntityDefinitionNotFoundError",
            "DuplicateLoginWithSuggestion",
            "EndpointNotFoundError",
            "FloodLimitError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "HtmlStrippedError",
            "InvalidConversationTypeError",
            "InvalidCustomFieldValueError",
            "InvalidCustomQuiltIdError",
            "InvalidDefaultQuiltIdError",
            "InvalidFontNameError",
            "InvalidHtmlError",
            "InvalidLoginValue",
            "InvalidPrivateConversationError",
            "InvalidQuiltError",
            "InvalidQuiltWrapperError",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MalformedUrl",
            "MaxRulesLimitError",
            "MaxWordsLimitError",
            "MessageFilterError",
            "MinimumAgeRequiredError",
            "NotValidPossibleValueError",
            "OperationNotSupportedForEntityError",
            "PrivateConversationNotFoundError",
            "PrivateNoteFilterError",
            "QuiltAlreadyExistsError",
            "QuiltNotFoundError",
            "QuiltWrapperNotFoundError",
            "ReplacementFormNotFoundError",
            "ReplacementQuiltNotFoundError",
            "ReplacementThemeNotFoundError",
            "RequiredCustomFieldNotSet",
            "RulesOverlapped",
            "ThemeAlreadyExistsError",
            "ThemeNotFoundError",
            "UploadLimitReached",
            "UserMentionsLimitReachedError",
            "UserSettingsFilterError"
        ],
        "EventModelEntity": [
            "AcceptedSolutionMessage",
            "Blog",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "Category",
            "Community",
            "Forum",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "GroupHub",
            "Idea",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "Occasion",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "Qanda",
            "Tkb",
            "TkbReplyMessage",
            "TkbTopicMessage",
            "User"
        ],
        "FeaturedWidgetUsage": [
            "FeaturedContentUsage",
            "FeaturedPlaceUsage",
            "FeaturedStatusesUsage"
        ],
        "FieldDefinition": [
            "FormField",
            "PropDefinition"
        ],
        "FloatCustomFormField": [
            "FloatInputField",
            "FloatRadioField",
            "FloatRangeField",
            "FloatSelectField"
        ],
        "FloatListCustomFormField": [
            "FloatListSelectField"
        ],
        "FollowAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "FollowApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "FollowUserAdministrative": [
            "User"
        ],
        "FollowUserApplicable": [
            "User"
        ],
        "Followable": [
            "AcceptedSolutionMessage",
            "Blog",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "Category",
            "Conversation",
            "Forum",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "GroupHub",
            "Idea",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "Occasion",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "Qanda",
            "Tag",
            "Tkb",
            "TkbReplyMessage",
            "TkbTopicMessage"
        ],
        "ForgotUserPasswordError": [
            "InputFieldsMissingError",
            "InvalidEmailError",
            "InvalidInputError"
        ],
        "FormError": [
            "FormNotFoundError",
            "InvalidFormFieldsError",
            "InvalidFormParseError",
            "RequiredFieldNotSetError"
        ],
        "FormLayoutItemColumn": [
            "FormCol",
            "FormFieldRef"
        ],
        "FormLayoutItemContainerRow": [
            "FormFieldset",
            "FormRow"
        ],
        "FormLayoutItemRow": [
            "FormFieldRef",
            "FormFieldset",
            "FormRow"
        ],
        "FormLayoutItemRowOrCol": [
            "FormCol",
            "FormFieldRef",
            "FormFieldset",
            "FormRow"
        ],
        "GithubOrganizationError": [
            "GithubNotEnabledError",
            "NoAppConfigError",
            "NoAppError",
            "NoOrgNameError",
            "NoRepoNameError"
        ],
        "GiveKudoToMessageError": [
            "GiveKudoToMessageFailedError",
            "GiveKudoToMessageLimitReachedError"
        ],
        "GroupHubContainer": [
            "Category",
            "Community"
        ],
        "GroupHubError": [
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "DuplicateGroupHubTitle",
            "DuplicateNodeId",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "GroupHubBoardIdSmutError",
            "GroupHubBoardNameSmutError",
            "GroupHubBoardNotProvidedError",
            "GroupHubDescriptionSmutError",
            "GroupHubIdSmutError",
            "GroupHubSubNodesDuplicateId",
            "GroupHubTitleSmutError",
            "IdMustBeAlphanumeric",
            "InvalidCustomFieldValueError",
            "InvalidNodeAvatar",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MustNotHaveAnyHtmlError",
            "NotValidPossibleValueError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldError",
            "ValidationError"
        ],
        "GuideContent": [
            "Chapter",
            "KBArticle"
        ],
        "GuideContentArticle": [
            "ChapterArticle",
            "GuideArticle"
        ],
        "HideSpamErrors": [
            "InsufficientPermissionsForUser",
            "OperationNotSupportedForEntityError"
        ],
        "IdeaStatusAdministrative": [
            "Idea"
        ],
        "IdeaStatusApplicable": [
            "Idea"
        ],
        "IgnoreReportedFilterEventError": [
            "IgnoreReportedEventFailedError",
            "InsufficientPermissionsForUser"
        ],
        "Image": [
            "AssociatedImage",
            "UploadedImage"
        ],
        "ImageAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "ImageApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "ImageAssociable": [
            "AcceptedSolutionMessage",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "PrivateNote",
            "TkbReplyMessage",
            "TkbTopicMessage"
        ],
        "ImportQuiltTemplateCoreNodesError": [
            "CoreNodeNotFoundError",
            "InvalidCoreNodeTypeForScopeError",
            "QuiltTemplateNotFoundError",
            "ValidationError"
        ],
        "ImportScopedAssetsError": [
            "CoreNodeNotFoundError",
            "InvalidCoreNodeTypeForScopeError",
            "PermissionDeniedError",
            "QuiltTemplateNotFoundError"
        ],
        "IntCustomFormField": [
            "IntInputField",
            "IntRadioField",
            "IntRangeField",
            "IntSelectField"
        ],
        "IntListCustomFormField": [
            "IntListSelectField"
        ],
        "InviteTokenVerificationError": [
            "ExpiredInviteTokenError",
            "InvalidInviteTokenError"
        ],
        "JoinNodeError": [
            "MembershipActionNotAllowed",
            "MembershipNodeNotFound",
            "MembershipUserNotFound",
            "NotAMembershipNode"
        ],
        "KnowledgeBaseAdministrative": [
            "Community"
        ],
        "KnowledgeBaseApplicable": [
            "Community"
        ],
        "LanguageAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "LanguageApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "LeaveNodeError": [
            "MembershipActionNotAllowed",
            "MembershipNodeNotFound",
            "NotAMember"
        ],
        "LinkProp": [
            "ExternalLinkProp",
            "ExternalLinkWithChildrenProp",
            "InternalLinkProp",
            "InternalLinkWithChildrenProp"
        ],
        "LinkWithChildrenProp": [
            "ExternalLinkWithChildrenProp",
            "InternalLinkWithChildrenProp"
        ],
        "LocalizedCategoriesAdministrative": [
            "Category"
        ],
        "LocalizedCategoriesApplicable": [
            "Category"
        ],
        "LongCustomFormField": [
            "LongInputField",
            "LongRangeField"
        ],
        "MaintenanceAdministrative": [
            "Community"
        ],
        "MaintenanceApplicable": [
            "Community"
        ],
        "MarkAllPrivateConversationsAsReadError": [
            "PermissionDeniedError"
        ],
        "MarkPrivateConversationAsReadError": [
            "PermissionDeniedError"
        ],
        "MediaSnippet": [
            "ExtractLinkSnippet",
            "VideoSnippet"
        ],
        "MembershipApplicable": [
            "GroupHub"
        ],
        "MentionsAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "MentionsApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "Message": [
            "AcceptedSolutionMessage",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "TkbReplyMessage",
            "TkbTopicMessage"
        ],
        "MessageAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "MessageApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "MessageAutosaveAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "MessageAutosaveApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "MessageError": [
            "AddTagLimitReachedError",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "FloodLimitError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "InvalidCustomFieldValueError",
            "InvalidHtmlError",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MessageFilterError",
            "NotValidPossibleValueError",
            "PermissionDeniedError",
            "RequiredCustomFieldNotSet",
            "UserMentionsLimitReachedError"
        ],
        "MessageEventModelEntity": [
            "AcceptedSolutionMessage",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "TkbReplyMessage",
            "TkbTopicMessage"
        ],
        "MessageSearchResult": [
            "DescendantMessageSearchResult",
            "TopLevelMessageSearchResult"
        ],
        "MessagesContainer": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "MetricGrid": [
            "BlogBoardReport",
            "BlogPostsReport",
            "CategoryReport",
            "ForumBoardReport",
            "ForumDiscussionsReport",
            "GroupHubReport",
            "IdeaBoardReport",
            "IdeasReport",
            "MemberReport",
            "MembersReport",
            "MetricDrillDownByPlacesData",
            "MetricDrillDownData",
            "NewTopicsByRepliesReport",
            "OccasionBoardReport",
            "PageViewsDrillDownReport",
            "PostsReport",
            "TKBArticlesReport",
            "TKBBoardReport",
            "TrafficMetricDrillDown",
            "TrafficMetricDrillDownByPlacesData",
            "TrendingTopicsByRepliesReport",
            "occasionsReport"
        ],
        "MetricGridIdRow": [
            "MembersReportRow",
            "PostsReportRow"
        ],
        "MetricGridRow": [
            "BlogBoardReportRow",
            "BlogPostsReportRow",
            "CategoryReportRow",
            "ForumBoardReportRow",
            "ForumDiscussionsReportRow",
            "GroupHubReportRow",
            "IdeaBoardReportRow",
            "IdeasReportRow",
            "MemberReportRow",
            "MetricDrillDownByPlacesRow",
            "NewTopicsByRepliesReportRow",
            "OccasionBoardReportRow",
            "OccasionsReportRow",
            "PageViewsDrillDownReportRow",
            "TKBArticlesReportRow",
            "TKBBoardReportRow",
            "TrafficMetricDrillDownByPlacesRow",
            "TrafficMetricDrillDownRow",
            "TrendingTopicsByRepliesReportRow"
        ],
        "ModerateAbuseMessageErrors": [
            "EntityAlreadyIgnoredAsNotAbuseError",
            "EntityAlreadyRejectedAsAbuseError",
            "EntityNotReportedError",
            "OperationNotSupportedForEntityError",
            "PermissionDeniedError"
        ],
        "ModerateAbuseUserErrors": [
            "EntityAlreadyModeratedError",
            "EntityNotReportedError",
            "OperationNotSupportedForEntityError",
            "PermissionDeniedError"
        ],
        "ModerateMessageError": [
            "PermissionDeniedError"
        ],
        "ModeratePrivateMessageErrors": [
            "EntityAlreadyRejectedAsAbuseError",
            "EntityNotRejectedAsAbuseError",
            "EntityNotReportedAsAbuseError",
            "EntityNotReportedError",
            "OperationNotSupportedForEntityError",
            "PermissionDeniedError"
        ],
        "ModerationAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "ModerationApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "MoveCategoryError": [
            "CategoryAssociatedToLocaleError",
            "InvalidMoveAfterNodeParentMismatchError",
            "InvalidMoveAfterNodeTypeMismatchError",
            "MoveAfterNodeNotFound",
            "NodeMoveFailedError"
        ],
        "MoveChapterArticleError": [
            "DuplicateKBArticleError",
            "GuideNotEnabledError",
            "InvalidArticleError",
            "InvalidChapterError",
            "InvalidContentError",
            "InvalidGuideError",
            "InvalidPositionSpecifiedError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "MoveGuideContentError": [
            "DuplicateKBArticleError",
            "GuideNotEnabledError",
            "InvalidArticleError",
            "InvalidChapterError",
            "InvalidContentError",
            "InvalidGuideError",
            "InvalidPositionSpecifiedError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "MoveMessageError": [
            "GreaterThanMaxValueError",
            "InvalidDestinationError",
            "MoveMessageFailedError",
            "PermissionDeniedError"
        ],
        "MoveNodeError": [
            "InvalidMoveAfterNodeParentMismatchError",
            "InvalidMoveAfterNodeTypeMismatchError",
            "MoveAfterNodeNotFound",
            "NodeMoveFailedError"
        ],
        "MoveScopedAssetsBranchError": [
            "MoveFromMainBranchNotAllowedError",
            "MoveToSameBranchNotAllowedError",
            "PermissionDeniedError"
        ],
        "MutePrivateConversationError": [
            "InvalidConversationTypeError",
            "InvalidPrivateConversationError",
            "PermissionDeniedError",
            "PrivateConversationNotFoundError"
        ],
        "Node": [
            "AbuseReport",
            "AbuseReportedMessage",
            "AbuseReportedPrivateMessage",
            "AbuseReportedUser",
            "AcceptedSolutionMessage",
            "ArchivedMessage",
            "Attachment",
            "AttachmentSearchResult",
            "Badge",
            "BadgeNotification",
            "BadgeSet",
            "Ban",
            "Blog",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "BoardNotification",
            "Category",
            "Community",
            "Conversation",
            "DescendantMessageSearchResult",
            "Follow",
            "Forum",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "GroupHub",
            "Idea",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "Invite",
            "Kudo",
            "KudosNotification",
            "MailTemplate",
            "MentionsNotification",
            "MessageAutosave",
            "MessageAutosaveData",
            "MessageNotification",
            "NodeSearchResult",
            "Occasion",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "PrivateConversation",
            "PrivateNote",
            "Product",
            "ProductCategory",
            "Qanda",
            "QuickMessageSearchResult",
            "Rank",
            "RankNotification",
            "RejectedPrivateMessage",
            "Role",
            "SalesforceCase",
            "SolutionsNotification",
            "SpamMessage",
            "Tag",
            "TagNotification",
            "Tkb",
            "TkbReplyMessage",
            "TkbTopicMessage",
            "TopLevelMessageSearchResult",
            "TopicNotification",
            "User",
            "UserSearchResult"
        ],
        "NodePolicies": [
            "BlogPolicies",
            "BoardPolicies",
            "CategoryPolicies",
            "ForumPolicies",
            "GroupHubPolicies",
            "IdeaPolicies",
            "OccasionPolicies",
            "QandaPolicies",
            "TkbPolicies"
        ],
        "Notification": [
            "BadgeNotification",
            "BoardNotification",
            "KudosNotification",
            "MentionsNotification",
            "MessageNotification",
            "RankNotification",
            "SolutionsNotification",
            "TagNotification",
            "TopicNotification"
        ],
        "NotificationAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "NotificationApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "NotificationUserAdministrative": [
            "User"
        ],
        "NotificationUserApplicable": [
            "User"
        ],
        "OccasionAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "OccasionMessageError": [
            "AddTagLimitReachedError",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "FloodLimitError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "InvalidCustomFieldValueError",
            "InvalidHtmlError",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MessageFilterError",
            "NotValidPossibleValueError",
            "OccasionValidationError",
            "PermissionDeniedError",
            "RequiredCustomFieldNotSet",
            "UserMentionsLimitReachedError"
        ],
        "ParentNode": [
            "Category",
            "Community",
            "GroupHub"
        ],
        "PermissionInheritable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Role",
            "Tkb"
        ],
        "Permissions": [
            "BlogPermissions",
            "CategoryPermissions",
            "CommunityPermissions",
            "ForumPermissions",
            "GroupHubPermissions",
            "IdeaPermissions",
            "OccasionPermissions",
            "TkbPermissions"
        ],
        "PopulateManualSortForBoardError": [
            "InvalidNodeError",
            "ManuallySortedError",
            "NoArticlesFoundError",
            "PermissionDeniedError"
        ],
        "PostModerationNotificationAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "PostModerationNotificationApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "PreviewVideo": [
            "AcceptedSolutionMessage",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "TkbReplyMessage",
            "TkbTopicMessage"
        ],
        "PrivacyPolicyErrors": [
            "LanguageCodeNotAllowedError",
            "PermissionDeniedError"
        ],
        "PrivateConversationAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "PrivateConversationApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "PrivateMessageType": [
            "PrivateConversation",
            "PrivateNote"
        ],
        "PrivateMessagesModerationNotificationAdministrative": [
            "Community"
        ],
        "PrivateMessagesModerationNotificationApplicable": [
            "Community"
        ],
        "ProcessVideoIFrameError": [
            "VideoUrlProcessError"
        ],
        "ProfileAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "ProfileUserAdministrative": [
            "User"
        ],
        "ProfileUserApplicable": [
            "User"
        ],
        "PromotedSearchRuleAdministrative": [
            "Community"
        ],
        "QuiltError": [
            "CreateOrUpdateQuiltFailedError",
            "InvalidCustomQuiltIdError",
            "InvalidDefaultQuiltIdError",
            "InvalidQuiltError",
            "QuiltAlreadyExistsError",
            "QuiltNotFoundError",
            "ReplacementQuiltNotFoundError"
        ],
        "QuiltItem": [
            "QuiltFooter",
            "QuiltHeader",
            "QuiltList"
        ],
        "QuiltSection": [
            "MainSideQuiltSection",
            "OneColumnQuiltSection",
            "SideMainQuiltSection",
            "ThreeColumnQuiltSection",
            "TwoColumnQuiltSection"
        ],
        "QuiltWrapperError": [
            "QuiltWrapperNotFoundError"
        ],
        "RankCreationError": [
            "DisallowedImageFormat",
            "GreaterThanMaxValueError",
            "RankingCreateError",
            "RankingFormulaError",
            "RankingIconError",
            "RankingIconInvalidExtensionError",
            "RankingNameError",
            "RankingRoleError",
            "UploadTooLarge",
            "ValidationError"
        ],
        "RankUpdateError": [
            "DisallowedImageFormat",
            "GreaterThanMaxValueError",
            "RankingFormulaError",
            "RankingIconError",
            "RankingIconInvalidExtensionError",
            "RankingNameError",
            "RankingRoleError",
            "RankingUpdateError",
            "UploadTooLarge",
            "ValidationError"
        ],
        "RatingAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "RatingApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "RegisterUserError": [
            "BannedEmail",
            "BannedLogin",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "DuplicateEmail",
            "DuplicateLogin",
            "DuplicateLoginWithSuggestion",
            "ExpiredInviteTokenError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "InvalidCustomFieldValueError",
            "InvalidEmailAddressError",
            "InvalidInviteTokenError",
            "InvalidLoginValue",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MinimumAgeRequiredError",
            "MinimumDigitError",
            "MinimumLowercaseError",
            "MinimumUppercaseError",
            "MustBeAlphanumericError",
            "MustNotHaveAnyHtmlError",
            "NotValidPossibleValueError",
            "RepeatedCharacterSequenceError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldNotSetError",
            "SameLogin",
            "SelfRegistrationNotAllowedError",
            "UserAcceptsTermsOfServiceRequiredError",
            "ValidationError"
        ],
        "RemoveAllowedLanguageResponseError": [
            "InsufficientPermissionsForUser",
            "InvalidLanguageError"
        ],
        "RemoveAssetError": [
            "AssetDoesNotExistError",
            "InvalidAssetDirectoryNameError",
            "InvalidAssetNameError"
        ],
        "RemoveAssetsError": [
            "AssetDoesNotExistError",
            "InvalidAssetDirectoryNameError",
            "InvalidAssetNameError"
        ],
        "RemoveMemberError": [
            "MembershipActionNotAllowed",
            "NotAMember"
        ],
        "RemovePageError": [
            "PageNotFoundError"
        ],
        "RemoveTagFromMessageError": [
            "RemoveTagFromMessageFailedError"
        ],
        "RemoveTextError": [
            "TextFileNotFoundError",
            "TextForComponentNotFoundError",
            "TextNotFoundError"
        ],
        "RemoveUsersFromRoleError": [
            "GreaterThanMaxValueError"
        ],
        "ReorderArticleError": [
            "InvalidArticleError",
            "InvalidNodeError",
            "InvalidPositionSpecifiedError",
            "ManualSortNotEnabledError",
            "PermissionDeniedError"
        ],
        "ReorderChapterArticleError": [
            "GuideNotEnabledError",
            "InvalidArticleError",
            "InvalidChapterError",
            "InvalidPositionSpecifiedError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "ReorderChapterError": [
            "GuideNotEnabledError",
            "InvalidChapterError",
            "InvalidContentError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "ReorderGuideContentError": [
            "GuideNotEnabledError",
            "InvalidContentError",
            "InvalidPositionSpecifiedError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "ReorderGuideError": [
            "GreaterThanMaxValueError",
            "GuideNotEnabledError",
            "InvalidGuideError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "RepliesAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "RepliesApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "ReplyMessage": [
            "AcceptedSolutionMessage",
            "BlogReplyMessage",
            "ForumReplyMessage",
            "IdeaReplyMessage",
            "OccasionReplyMessage",
            "TkbReplyMessage"
        ],
        "ReportAbuseErrors": [
            "DuplicateEmail",
            "GreaterThanMaxValueError",
            "InvalidAbuseReportReasonError",
            "InvalidAbuseReportReportedForError",
            "InvalidEmailAddressError",
            "LessThanMinValueError",
            "OperationNotSupportedForEntityError",
            "PermissionDeniedError",
            "ValidationError"
        ],
        "ReportAbuseInPrivateNoteErrors": [
            "ReportAuthoredNoteError",
            "ReportNoteFloodError"
        ],
        "Repository": [
            "GithubRepository"
        ],
        "ResendEmailInviteError": [
            "BannedEmail",
            "EmailAddressAlreadyExistsError",
            "EmailAddressNotInvitedError",
            "PermissionDeniedError"
        ],
        "ResendInviteError": [
            "InvalidEmailFormatError",
            "MembershipUserNotFound",
            "PermissionDeniedError",
            "SendInvitesNullError"
        ],
        "ResendOccasionInviteError": [
            "CannotParseInputError",
            "EmailInviteNotEnabledError",
            "InvalidEmailAddressError",
            "InviteLimitReachedError",
            "OccasionEndedError",
            "OccasionNotFoundError",
            "PermissionDeniedError"
        ],
        "ResetBranchError": [
            "BranchDoesNotExistsError",
            "CannotResetBranchError"
        ],
        "ResetPermissionsForNodeError": [
            "CoreNodeNotFoundError",
            "PermissionDeniedError"
        ],
        "ResetUserPasswordError": [
            "AccountLockedOutError",
            "ChangePasswordError",
            "GreaterThanMaxValueError",
            "InvalidUserPropertyError",
            "LessThanMinValueError",
            "MinimumDigitError",
            "MinimumLowercaseError",
            "MinimumUppercaseError",
            "MustNotHaveAnyHtmlError",
            "RepeatedCharacterSequenceError",
            "ValidationError"
        ],
        "RevisionsDiffError": [
            "InsufficientPermissionsForUser",
            "NoSuchMessageError",
            "NoSuchRevisionError"
        ],
        "RevokeDeveloperAccessTokenError": [
            "AccessTokenRevokeFailedError",
            "FeatureNotConfiguredError",
            "NoInternalApiAppError",
            "PermissionDeniedError",
            "UserNotRegistered"
        ],
        "RevokeKudoFromMessageError": [
            "RevokeKudoFromMessageFailedError"
        ],
        "RobotsCustomRulesAdministrative": [
            "Community"
        ],
        "RobotsCustomRulesApplicable": [
            "Community"
        ],
        "SalesforceAdministrative": [
            "Community"
        ],
        "SalesforceCaseError": [
            "InvalidHtmlError",
            "MessageNotEscalatedError",
            "PermissionDeniedError",
            "SalesforceCaseAttachmentError",
            "SalesforceCaseCloseError",
            "SalesforceCaseCommentError",
            "SalesforceCaseCreateError",
            "SalesforceCaseCreateInternalError",
            "SalesforceCaseFetchError",
            "SalesforceCaseUpdateError",
            "SalesforceMessageEscalationError",
            "SalesforceUserSyncError",
            "UserNotExistError"
        ],
        "SalesforceMessage": [
            "AcceptedSolutionMessage",
            "ForumReplyMessage",
            "ForumTopicMessage"
        ],
        "SalesforceUserAdministrative": [
            "User"
        ],
        "SalesforceUserSyncAdministrative": [
            "Community"
        ],
        "SamlAdministrative": [
            "Community"
        ],
        "SamlApplicable": [
            "Community"
        ],
        "SearchMessageEventError": [
            "InvalidMessageId"
        ],
        "SearchSettingsAdministrative": [
            "Community"
        ],
        "SearchSettingsApplicable": [
            "Community"
        ],
        "SendEmailInviteError": [
            "BannedEmail",
            "DuplicateEmail",
            "EmailAddressAlreadyExistsError",
            "EmailAddressAlreadyInvitedError",
            "InvalidEmailAddressError",
            "PermissionDeniedError",
            "RoleNotFoundError"
        ],
        "SendInviteError": [
            "InvalidEmailFormatError",
            "MembershipInvitesLimitReached",
            "PermissionDeniedError",
            "RoleNotFoundError",
            "SendInvitesNullError"
        ],
        "SendInviteTypeAdministrative": [
            "Category",
            "Community",
            "GroupHub"
        ],
        "SendInviteTypeApplicable": [
            "Category",
            "Community",
            "GroupHub"
        ],
        "SeoAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "SeoApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "SetCustomFieldEscalationSettingError": [
            "CustomFieldEscalationSettingError",
            "CustomFieldNameNotUniqueError",
            "InvalidSettingValueError",
            "NoSuchNodeError",
            "PermissionDeniedError",
            "ValidationError"
        ],
        "SetDefaultThemeError": [
            "PermissionDeniedError",
            "ThemeNotFoundError"
        ],
        "SetLocaleToCategoryError": [
            "CoreNodeNotFoundError",
            "InvalidCategoryError",
            "InvalidLocaleAssociationError",
            "InvalidNodeTypeError",
            "LanguageNotAllowed",
            "PermissionDeniedError"
        ],
        "SetMessageEditsFrozenError": [
            "FreezeEditsAlreadySetError",
            "MessageBoardNotTkbError",
            "MessageUpdateFailedError",
            "PermissionDeniedError"
        ],
        "SetMessageReadOnlyError": [
            "MessageUpdateFailedError",
            "PermissionDeniedError",
            "ReadOnlyAlreadySetError"
        ],
        "SetPermissionError": [
            "InvalidNodeLevelPermissionsError",
            "InvalidNodeTypeError",
            "PermissionDeniedError"
        ],
        "SetQuiltNodeScopeError": [
            "CoreNodeNotFoundError",
            "InvalidCoreNodeTypeForScopeError",
            "PermissionDeniedError",
            "QuiltNotFoundError",
            "RequiredFieldNotSetError"
        ],
        "SetSettingsError": [
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "DateMustNotHaveCapitalYError",
            "DateMustNotHaveTimeFormatError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "HtmlStrippedError",
            "InvalidCustomFieldValueError",
            "InvalidEmailAddressError",
            "InvalidInputError",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MustNotHaveAnyHtmlError",
            "NotValidDateFormatError",
            "NotValidPossibleValueError",
            "RequiredCustomFieldNotSet",
            "SetSettingsFailedError",
            "ValidationError"
        ],
        "SetThemeQuiltScopeError": [
            "PermissionDeniedError",
            "QuiltNotFoundError",
            "ThemeNotFoundError"
        ],
        "Settings": [
            "AnalyticsSettings",
            "AttachmentSettings",
            "AuthSettings",
            "BlogModerationSettings",
            "CWASettings",
            "CaseEscalationSettings",
            "CasePortalSettings",
            "ChatSettings",
            "CommunitySalesforceSettings",
            "CustomFieldSettings",
            "DevBranchSettings",
            "EmailSettings",
            "EmojiSettings",
            "EmojiUserSettings",
            "EndpointSettings",
            "FollowSettings",
            "FollowUserSettings",
            "ForumModerationSettings",
            "IdeaModerationSettings",
            "ImageSettings",
            "LanguageSettings",
            "MessageAutosaveSettings",
            "MessageSettings",
            "NotificationSettings",
            "NotificationUserSettings",
            "OccasionModerationSettings",
            "OccasionSettings",
            "PrivateConversationSettings",
            "ProfileSettings",
            "PromotedSearchRuleSettings",
            "QandaModerationSettings",
            "RatingSettings",
            "RepliesSettings",
            "SalesforceSettings",
            "SalesforceUserSettings",
            "SalesforceUserSyncSettings",
            "SamlSettings",
            "SeoSettings",
            "SsoSettings",
            "TagCommunitySettings",
            "TagNodeSettings",
            "TkbModerationSettings",
            "UserLastSyncDateSettings",
            "UserManagementSettings",
            "VideoSettings"
        ],
        "SolutionError": [
            "PermissionDeniedError"
        ],
        "SsoAdministrative": [
            "Community"
        ],
        "SsoApplicable": [
            "Community"
        ],
        "StoreFeaturedContentError": [
            "CoreNodeNotFoundError",
            "FeaturedWidgetNotFoundError",
            "GreaterThanMaxValueError",
            "InvalidMessageError",
            "InvalidNodeTypeError",
            "MessageNotFoundError",
            "PermissionDeniedError"
        ],
        "StoreFeaturedGuidesError": [
            "CoreNodeNotFoundError",
            "FeaturedWidgetNotFoundError",
            "GreaterThanMaxValueError",
            "GuideNotEnabledError",
            "InvalidGuideError",
            "InvalidQuiltIdError",
            "PermissionDeniedError"
        ],
        "StoreFeaturedPlacesError": [
            "CoreNodeNotFoundError",
            "FeaturedWidgetNotFoundError",
            "GreaterThanMaxValueError",
            "InvalidNodeTypeError",
            "PermissionDeniedError"
        ],
        "StoreFeaturedStatusError": [
            "FeaturedWidgetNotFoundError",
            "IdeaBoardNotFoundError",
            "InvalidNodeTypeError",
            "InvalidQuiltIdError",
            "InvalidStatusKeyError",
            "PermissionDeniedError"
        ],
        "StringCustomFormField": [
            "PasswordField",
            "RteField",
            "StringInputField",
            "StringRadioField",
            "StringSelectField",
            "TextareaField"
        ],
        "StringListCustomFormField": [
            "StringListSelectField"
        ],
        "TagAdministrative": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "TagApplicable": [
            "Blog",
            "Category",
            "Community",
            "Forum",
            "GroupHub",
            "Idea",
            "Occasion",
            "Qanda",
            "Tkb"
        ],
        "TagProperties": [
            "TagCommunityProperties",
            "TagNodeProperties"
        ],
        "TagSettings": [
            "TagCommunitySettings",
            "TagNodeSettings"
        ],
        "TemporaryOverrideable": [
            "Asset",
            "Component",
            "ComponentTemplate",
            "CustomFieldDefinitionResource",
            "CustomFieldsEntityDefinitionResource",
            "NavbarProps",
            "PageResource",
            "PagesResponse",
            "Quilt",
            "QuiltWrapper",
            "TextResource",
            "Theme"
        ],
        "TermsOfServiceErrors": [
            "LanguageCodeNotAllowedError",
            "PermissionDeniedError"
        ],
        "ThemeError": [
            "BaseThemeNotFoundError",
            "CreateOrUpdateThemeFailedError",
            "InvalidFontNameError",
            "ReplacementThemeNotFoundError",
            "ThemeAlreadyExistsError",
            "ThemeNotFoundError"
        ],
        "ThemeQueryError": [
            "ThemeNotFoundError"
        ],
        "TimezoneApplicable": [
            "Community"
        ],
        "TopicMessage": [
            "BlogTopicMessage",
            "ForumTopicMessage",
            "IdeaTopicMessage",
            "OccasionTopicMessage",
            "TkbTopicMessage"
        ],
        "TypedEntity": [
            "AcceptedSolutionMessage",
            "Blog",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "Category",
            "Community",
            "Forum",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "GroupHub",
            "Idea",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "MessageAutosaveData",
            "Occasion",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "Qanda",
            "SalesforceCase",
            "Tkb",
            "TkbReplyMessage",
            "TkbTopicMessage",
            "User"
        ],
        "UnarchiveMessageError": [
            "ArchivalFeatureNotEnabledError",
            "InvalidNodeError",
            "InvalidTargetNodeForUnarchivalError",
            "MessageArchivalQueuedError",
            "MessageNotArchivedError",
            "MessageNotFoundError",
            "MessageReplyUnarchivalNotAllowedError",
            "MessageUnarchivalFailedError",
            "PermissionDeniedError"
        ],
        "UnmutePrivateConversationError": [
            "InvalidConversationTypeError",
            "InvalidPrivateConversationError",
            "PermissionDeniedError",
            "PrivateConversationNotFoundError"
        ],
        "UpdateAllowedLanguagesResponseError": [
            "DefaultLanguageError",
            "InsufficientPermissionsForUser",
            "InvalidLanguageError",
            "LanguageNotEnabled",
            "OperationNotSupportedForEntityError",
            "UserNotFoundError"
        ],
        "UpdateChapterError": [
            "GreaterThanMaxValueError",
            "GuideNotEnabledError",
            "InvalidChapterError",
            "InvalidGuideError",
            "PermissionDeniedError",
            "UnsupportedConversationStyleError"
        ],
        "UpdateCommunityError": [
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "InvalidCustomFieldValueError",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MustNotHaveAnyHtmlError",
            "NotValidPossibleValueError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldError",
            "UpdateCommunityFailedError",
            "ValidationError"
        ],
        "UpdateGuideError": [
            "DisallowedImageFormat",
            "GreaterThanMaxValueError",
            "GuideNotEnabledError",
            "InvalidCropProps",
            "InvalidGuideError",
            "PermissionDeniedError",
            "TooManyUploadedImages",
            "UnsupportedConversationStyleError",
            "UploadFailed",
            "UploadLimitReached",
            "UploadTooLarge"
        ],
        "UpdateNodeError": [
            "CannotSetRequireTagsError",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotSettable",
            "DuplicateTagError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "InvalidCustomFieldValueError",
            "InvalidNodeAvatar",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "MustNotHaveAnyHtmlError",
            "NotValidPossibleValueError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldError",
            "ValidateUnsafeCharError",
            "ValidationError"
        ],
        "UpdateRelatedContentUrlError": [
            "ArchivalFeatureNotEnabledError",
            "InvalidUrlError",
            "MessageArchivalQueuedError",
            "MessageNotArchivedError",
            "MessageNotFoundError",
            "PermissionDeniedError",
            "RelatedUrlNotAllowedForRepliesError"
        ],
        "UpdateRsvpResponseError": [
            "RsvpOccasionValidationError",
            "RsvpResponseValidationError"
        ],
        "UpdateRuleError": [
            "DefaultError",
            "InvalidRuleId",
            "MaxWordsLimitError",
            "RulesOverlapped"
        ],
        "UpdateUserAvatarError": [
            "MalformedUrl",
            "PermissionDeniedError",
            "UserNotFoundError"
        ],
        "UpdateUserEmailError": [
            "AccountLockedOutError",
            "BannedEmail",
            "DuplicateEmail",
            "GreaterThanMaxValueError",
            "IncorrectPassword",
            "InvalidEmailAddressError",
            "LessThanMinValueError",
            "MustBeAlphanumericError",
            "SameEmail"
        ],
        "UpdateUserError": [
            "BannedEmail",
            "BannedLogin",
            "CustomFieldNotDefinedForEntityError",
            "CustomFieldNotRemovable",
            "CustomFieldNotSettable",
            "DateMustNotHaveCapitalYError",
            "DateMustNotHaveTimeFormatError",
            "DuplicateEmail",
            "DuplicateLogin",
            "DuplicateLoginWithSuggestion",
            "DuplicatedSSOIdError",
            "GreaterThanMaxItemsError",
            "GreaterThanMaxValueError",
            "HasInvalidHtmlTagError",
            "HtmlStrippedError",
            "InvalidCustomFieldValueError",
            "InvalidEmailAddressError",
            "InvalidLoginValue",
            "InvalidUriError",
            "InvalidUserAvatar",
            "LanguageNotAllowed",
            "LessThanMinItemsError",
            "LessThanMinValueError",
            "LoginCannotBeChangedError",
            "MustBeAlphanumericError",
            "MustNotHaveAnyHtmlError",
            "NonSsoUserError",
            "NotValidDateFormatError",
            "NotValidPossibleValueError",
            "PermissionDeniedError",
            "RequiredCustomFieldNotSet",
            "RequiredFieldNotSetError",
            "SameEmail",
            "SameLogin",
            "SsoFirstAndLastNameUpdateNotAllowedError",
            "UrlMustUseHttpOrHttpsError",
            "UserSettingsFilterError",
            "ValidationError"
        ],
        "UpdateUserLoginError": [
            "AccountLockedOutError",
            "BannedLogin",
            "DuplicateLogin",
            "DuplicateLoginWithSuggestion",
            "GreaterThanMaxValueError",
            "IncorrectPassword",
            "InvalidLoginValue",
            "LessThanMinValueError",
            "MustBeAlphanumericError",
            "PermissionDeniedError",
            "SameLogin"
        ],
        "UserCloseAccountAdministrative": [
            "Community"
        ],
        "UserCloseAccountApplicable": [
            "Community"
        ],
        "UserEventModelEntity": [
            "User"
        ],
        "UserManagementAdministrative": [
            "Community"
        ],
        "UserManagementApplicable": [
            "Community"
        ],
        "UserModerationNotificationAdministrative": [
            "Community"
        ],
        "UserModerationNotificationApplicable": [
            "Community"
        ],
        "UserSyncLastDateAdministrative": [
            "Community"
        ],
        "VerifyMaxAttachmentFileSizeForUploadError": [
            "GreaterThanMaxValueError",
            "LessThanMinValueError"
        ],
        "VerifyMaxImageFileSizeForUploadError": [
            "GreaterThanMaxValueError",
            "LessThanMinValueError"
        ],
        "VerifyMaxVideoFileSizeForUploadError": [
            "GreaterThanMaxValueError",
            "LessThanMinValueError"
        ],
        "VerifyNavbarPropsUrlError": [
            "InvalidUriError"
        ],
        "VerifyUserEmailError": [
            "BannedEmail",
            "DuplicateEmail",
            "GreaterThanMaxValueError",
            "InvalidEmailAddressError",
            "LessThanMinValueError",
            "RequiredFieldNotSetError",
            "SameEmail"
        ],
        "VerifyUserLoginError": [
            "BannedLogin",
            "DuplicateLogin",
            "DuplicateLoginWithSuggestion",
            "GreaterThanMaxValueError",
            "InvalidLoginValue",
            "LessThanMinValueError",
            "MustBeAlphanumericError",
            "SameLogin",
            "UserSettingsFilterError"
        ],
        "WebViewableEntity": [
            "AcceptedSolutionMessage",
            "Blog",
            "BlogReplyMessage",
            "BlogTopicMessage",
            "Category",
            "Community",
            "Forum",
            "ForumReplyMessage",
            "ForumTopicMessage",
            "GroupHub",
            "Idea",
            "IdeaReplyMessage",
            "IdeaTopicMessage",
            "MessageAutosaveData",
            "Occasion",
            "OccasionReplyMessage",
            "OccasionTopicMessage",
            "Qanda",
            "SalesforceCase",
            "Tkb",
            "TkbReplyMessage",
            "TkbTopicMessage",
            "User"
        ]
    }
};
exports.default = result;
//# sourceMappingURL=graphql-fragment-types.js.map